// redux/allAction/tenantPlanActions.js
// Action Types
export const SET_TENANT_PLAN = 'SET_TENANT_PLAN';
export const FETCH_TENANT_PLAN_REQUEST = 'FETCH_TENANT_PLAN_REQUEST';
export const FETCH_TENANT_PLAN_SUCCESS = 'FETCH_TENANT_PLAN_SUCCESS';
export const FETCH_TENANT_PLAN_FAILURE = 'FETCH_TENANT_PLAN_FAILURE';

// Simple action creator (already exists in your code)
export const setTenantPlanAct = (data) => ({
  type: SET_TENANT_PLAN,
  payload: data
});

// New action creators
export const fetchTenantPlanRequest = () => ({
  type: FETCH_TENANT_PLAN_REQUEST
});

export const fetchTenantPlanSuccess = (data) => ({
  type: FETCH_TENANT_PLAN_SUCCESS,
  payload: data
});

export const fetchTenantPlanFailure = (error) => ({
  type: FETCH_TENANT_PLAN_FAILURE,
  payload: error
});

// Thunk action to fetch tenant plan
export const fetchTenantPlan = () => {
  return async (dispatch, getState) => {
    try {
      // Check if data already exists in store
      const { tenantPlan } = getState();
      if (tenantPlan?.data && !tenantPlan?.shouldRefetch) {
        console.log('Tenant plan data already exists, skipping fetch');
        return;
      }

      dispatch(fetchTenantPlanRequest());

      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authentication token found");
      }

      const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

      const response = await fetch(
        `https://mgmt-util2.${backend_api_base_url}/get_tenant_plan`,
        {
          method: "GET",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch tenant plan: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        dispatch(fetchTenantPlanSuccess(result.data));
        // Also dispatch the setTenantPlanAct for backward compatibility
        dispatch(setTenantPlanAct(result.data));
        console.log('Tenant plan fetched successfully:', result.data);
      } else {
        throw new Error(result.message || "Failed to fetch tenant plan");
      }
    } catch (error) {
      console.error("Error fetching tenant plan:", error);
      dispatch(fetchTenantPlanFailure(error.message));
    }
  };
};